import { io } from 'socket.io-client';
import { resolveSocketUrl } from './socketUrl';

let socket = null;
let refCount = 0;

/**
 * Shared Socket.IO connection for platform presence (one socket per browser tab).
 */
export function acquirePresenceSocket() {
  refCount += 1;
  if (!socket) {
    socket = io(resolveSocketUrl(), {
      transports: ['websocket', 'polling'],
      path: process.env.REACT_APP_SOCKET_PATH || '/socket.io'
    });
  }
  return socket;
}

export function releasePresenceSocket() {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0 && socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getPresenceSocket() {
  return socket;
}
